import React from "react";
import Html from "./html";
import { Provider } from "./provider";

const SearchResults = () => {
    return (
        <Provider>
            <Html/>
        </Provider>
    );
}

export default SearchResults;